import { render, staticRenderFns } from "./NftManage.vue?vue&type=template&id=21f9e056&scoped=true"
import script from "./NftManage.vue?vue&type=script&lang=js"
export * from "./NftManage.vue?vue&type=script&lang=js"
import style0 from "./NftManage.vue?vue&type=style&index=0&id=21f9e056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f9e056",
  null
  
)

export default component.exports